import React, { useEffect } from 'react';

import { ChatCircleDots } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Form } from 'src/components/Form';
import { Head } from 'src/components/Head';
import {
  TrackGoogleAnalyticsEvent,
  TrackGoogleAnalyticsPageView,
} from 'src/utils/google-analytics';

import { Container, Content, LeftContent } from './styles';

export function ContactSales() {
  const { t: translate } = useTranslation();

  const location = useLocation();

  useEffect(() => {
    TrackGoogleAnalyticsPageView(location.pathname, 'Tela de Falar com Vendas');
  }, [location.pathname]);

  return (
    <Container>
      <Head
        title={translate('contactSalesPageHeadTitle')}
        description={translate('contactSalesPageHeadDescription') ?? ''}
      />

      <Content>
        <LeftContent>
          <h2>{translate('contactSalesPageTitle')}</h2>

          <p>{translate('contactSalesPageDescription')}</p>

          <Link
            to="https://api.whatsapp.com/message/EZT5JXA7LWKUK1?autoload=1&app_absent=0"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              TrackGoogleAnalyticsEvent(
                'Falar pelo Whatsapp',
                'Falar pelo Whatsapp',
                location.pathname,
              );
            }}
          >
            <ChatCircleDots weight="fill" />
            {translate('contactSalesPageWhatsappButton')}
          </Link>
        </LeftContent>

        <Form
          hubspotFormId={process.env.REACT_APP_HUBSPOT_FORM_ID ?? ''}
          hubspotPortalId={process.env.REACT_APP_HUBSPOT_PORTAL_ID ?? ''}
          privacyPolicy={process.env.REACT_APP_PRIVACY_POLICY ?? ''}
        />
      </Content>
    </Container>
  );
}
